import { Record } from 'immutable';

const BrandRecord = Record({
    brandCode: null,
    name: null
});

export class Brand extends BrandRecord {
    brandCode: string;
    name: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/chain-brand/brand.ts